module.exports = require('./dist/SAlert');


//////////////////
// WEBPACK FOOTER
// P:/Work/htdocs/biatlon/online/~/react-s-alert/index.js
// module id = 276
// module chunks = 0